var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_3916)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74026 7.17042H15.0017C15.1577 7.17042 15.284 7.04256 15.284 6.88414C15.284 6.72573 15.1577 6.59741 15.0017 6.59741H6.74026C6.5842 6.59741 6.4574 6.72573 6.4574 6.88414C6.4574 7.04256 6.5842 7.17042 6.74026 7.17042Z",
    fill: "#ADB84E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.284 9.40224C15.284 9.2443 15.1577 9.11597 15.0017 9.11597H6.74026C6.5842 9.11597 6.4574 9.2443 6.4574 9.40224C6.4574 9.56065 6.5842 9.68897 6.74026 9.68897H15.0017C15.1577 9.68897 15.284 9.56065 15.284 9.40224Z",
    fill: "#ADB84E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7768 19.0239L14.6622 14.5198L20.7768 10.0156V19.0239ZM2.05106 19.7897L8.07979 15.0566L10.7895 17.0455C10.9399 17.1559 11.1443 17.1536 11.293 17.0398L13.8758 15.0594L19.9524 19.7897H2.05106ZM1.23499 10.0156L7.35012 14.5198L1.23499 19.0239V10.0156ZM4.04918 7.17646V10.945L1.52621 9.04684L4.04918 7.17646ZM4.89635 5.48893C4.89635 4.71614 5.5559 4.08767 6.36685 4.08767H15.6459C16.4564 4.08767 17.1159 4.71614 17.1159 5.48893V11.6501L13.7825 14.1057C13.7263 14.1188 13.6715 14.1395 13.6227 14.1767L11.0319 16.1627L8.31945 14.1715L4.89635 11.6501V5.48893ZM11.0059 2.01938L12.6362 3.22792H9.37611L11.0059 2.01938ZM17.9631 7.17646L20.4944 9.05295L18.0532 10.96L17.9631 11.0258V7.17646ZM21.4503 8.69712L17.9631 6.11177V5.48893C17.9631 4.24232 16.9232 3.22792 15.6459 3.22792H14.0718L11.2558 1.14036C11.1072 1.03036 10.9051 1.03036 10.756 1.14036L7.93997 3.22792H6.36685C5.08865 3.22792 4.04918 4.24232 4.04918 5.48893V6.11177L0.561509 8.69712C0.452825 8.77797 0.388282 8.90629 0.387817 9.04261C0.387817 9.06658 0.392465 9.09009 0.39618 9.11359C0.393393 9.13333 0.387817 9.15214 0.387817 9.17235V19.8672C0.387817 19.9302 0.405469 19.9895 0.430085 20.0445C0.38689 20.1418 0.375271 20.2522 0.411035 20.3585C0.469093 20.5324 0.630251 20.649 0.811856 20.649H21.2004C21.382 20.649 21.5432 20.5319 21.6017 20.3575C21.637 20.2518 21.6249 20.1413 21.5817 20.0445C21.6073 19.9895 21.624 19.9302 21.624 19.8672V9.17235C21.624 9.15261 21.6184 9.13427 21.6161 9.11547C21.6203 9.09009 21.6245 9.06471 21.624 9.03885C21.6221 8.90394 21.558 8.77703 21.4503 8.69712Z",
    fill: "#ADB84E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_3916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8298,
    height: 20.2128,
    fill: "white",
    transform: "translate(0 0.808594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ab6ed714b12cdd02e4ee4f62d550458e.svg";
export { ForwardRef as ReactComponent };